import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "bg-yellow-200 text-yellow-800 px-3 py-0.5 text-xs rounded-xl truncate" }
const _hoisted_2 = ["src"]

import { computed, onMounted, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import logger from "shared/services/logger";
import defaultProjectThumbnailUrl from "@/assets/imgs/default-project-thumbnail.jpg";
import { useStreams } from "@/composables/stream";
import StreamRepository from "@/repositories/StreamRepository";
import BaseWidget from "@/views/dashboard/componentsV2/BaseWidget.vue";
import DashboardDragHandle from "@/views/dashboard/componentsV2/DashboardDragHandle.vue";
import { useVideoPlayerDimensions } from "@/views/dashboard/composables";
import { liveStreamWidgetHeaderHeight } from "@/views/dashboard/services/projectOverviewV2Layout";


export default /*#__PURE__*/_defineComponent({
  __name: 'ArchivedStreamWidget',
  props: {
    arg: {},
    width: {},
    height: {}
  },
  emits: ["delete", "widgetRouteClicked"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const { t } = useI18n();

const isLoading = ref(false);
const thumbnailUrl = ref<string | null>(null);
const containerRef = ref<HTMLDivElement | null>(null);

const playerDimensions = useVideoPlayerDimensions(containerRef);
const { streams } = useStreams();
const stream = computed(() => streams.value.find(({ camera_id }) => camera_id === props.arg));

const loadImage = () => {
  if (!stream.value || !stream.value.thumbnail_url || isLoading.value) {
    return;
  }

  isLoading.value = true;
  StreamRepository.loadThumbnail(stream.value.thumbnail_url)
    .then((thumbnail) => {
      thumbnailUrl.value = thumbnail;
    })
    .catch((error) => {
      thumbnailUrl.value = null;
      logger.error(error);
    })
    .finally(() => {
      isLoading.value = false;
    });
};

watch(
  () => stream.value,
  () => {
    loadImage();
  },
);

onMounted(() => {
  loadImage();
});

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(BaseWidget, {
    isLoading: isLoading.value,
    onDelete: _cache[1] || (_cache[1] = ($event: any) => (emit('delete'))),
    hideDragHandle: "",
    menuClass: "top-4"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "h-full flex flex-col",
        ref_key: "containerRef",
        ref: containerRef
      }, [
        _createElementVNode("div", {
          class: "flex items-center pl-4 pr-7 py-4 gap-2",
          style: _normalizeStyle({ height: `${_unref(liveStreamWidgetHeaderHeight)}px` })
        }, [
          _createVNode(DashboardDragHandle, { class: "shrink-0" }),
          (stream.value)
            ? (_openBlock(), _createBlock(_component_RouterLink, {
                key: 0,
                to: {
            name: 'ProjectTimelapse',
            params: {
              customer_name: stream.value.customer_name,
              site_id: stream.value.site_id,
              camera_id: stream.value.camera_id,
            },
          },
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emit('widgetRouteClicked')), ["prevent"])),
                class: "font-semibold text-gray-900 truncate text-lg hover:text-yellow-800"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(stream.value?.name), 1)
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)("dashboard.stream.archived_stream")), 1)
        ], 4),
        _createElementVNode("div", {
          class: "flex flex-col items-center",
          style: _normalizeStyle({ 'background-color': thumbnailUrl.value ? '#000' : '#f2f5f8' }),
          "data-oai-left-over-space-calculator": "ignore"
        }, [
          _createElementVNode("img", {
            src: thumbnailUrl.value ?? undefined,
            alt: "",
            class: "bg-transparent bg-no-repeat bg-center bg-contain object-contain",
            style: _normalizeStyle({
            backgroundImage: `url('${_unref(defaultProjectThumbnailUrl)}')`,
            textIndent: '-1000px',
            width: `${_unref(playerDimensions).width}px`,
            height: `${_unref(playerDimensions).height}px`,
          })
          }, null, 12, _hoisted_2)
        ], 4)
      ], 512)
    ]),
    _: 1
  }, 8, ["isLoading"]))
}
}

})